import { createFileRoute } from '@tanstack/react-router'
import { tenantQueryOptions } from '../../../../features/platform/queries'
import { ConsoleRouteError } from '../../../../features/platform/route-states'
import { tenantDetailSearchSchema } from '../../../../features/platform/search'
import { TenantDetailPage } from '../../../../features/platform/tenant-detail-page'

export const Route = createFileRoute('/platform/_console/tenants/$tenantId')({
  validateSearch: tenantDetailSearchSchema,
  // A missing tenant (or a malformed id) is a 404 here, shown with the way back to the list.
  loader: ({ context, params }) => context.queryClient.ensureQueryData(tenantQueryOptions(params.tenantId)),
  component: TenantDetailPage,
  errorComponent: ConsoleRouteError,
})
